/* eslint-disable */
import { enums } from "../enums/";
import { getRequest } from '../utils/requestHelper';
import { ACTION_TYPE } from './ActionTypes';



export const sortOrganizations = (organizations, order, orderBy) => (dispatch) => {
  dispatch({ type: 'SORT_ORGANIZATIONS', payload: { organizations, order, orderBy } });
};

export const sortOrganizationUsers = (organizationUsers, order, orderBy) => (dispatch) => {
  dispatch({ type: 'SORT_ORGANIZATION_USERS', payload: { organizationUsers, order, orderBy } });
};

export const sortOrganizationProducingAssets = (organizationProducingAssets, order, orderBy) => (dispatch) => {
  dispatch({ type: 'SORT_ORGANIZATION_PRODUCING_ASSETS', payload: { organizationProducingAssets, order, orderBy } });
};

export const sortOrganizationConsumingAssets = (organizationAssetsConsuming, order, orderBy) => (dispatch) => {
  dispatch({ type: 'SORT_ORGANIZATION_CONSUMING_ASSETS', payload: { organizationAssetsConsuming, order, orderBy } });
};

export const changePage = (page) => (dispatch) => {
  dispatch({ type: 'CHANGE_PAGE', payload: { page } });
};

export const changeRowsPerPage = (rowsPerPage) => (dispatch) => {
  dispatch({ type: 'CHANGE_ROWS_PER_PAGE', payload: { rowsPerPage } });
};

export const createOrganizationStart = (currentOrganization, file, history) => async (dispatch) => {


  dispatch({ type: 'CREATE_ORGANIZATION_START' });

  const createdOrganization = await createOrganization(currentOrganization)
    .catch(error => {
      console.error(error);
      createOrganizationFail('Error creating organization', dispatch);
    });

  if (createdOrganization) {

    if (file) {
      createdOrganization.pictureFileName = await uploadOrganizationPicture(file, createdOrganization._id);

      await setOrganization(createdOrganization._id, createdOrganization).catch(error => {
        dispatch({ type: 'CREATE_ORGANIZATION_FAIL' });
        dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
      });
    }

    createOrganizationSuccess(createdOrganization._id, history, dispatch);
  }
};

export const createOrganizationSuccess = (organizationId, history, dispatch) => {

  dispatch({ type: 'CREATE_ORGANIZATION_SUCCESS' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'New organization created !' });
  history.push('/organizations/read/' + organizationId);
};

export const createOrganizationFail = (error, dispatch) => {

  dispatch({ type: 'CREATE_ORGANIZATION_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

export const updateOrganizationStart = (organizationId, organization, file, history) => async (dispatch) => {
  dispatch({ type: 'UPDATE_ORGANIZATION_START' });
  

  let updatedOrganization = await setOrganization(organizationId, organization).catch(error => {
    dispatch({ type: 'UPDATE_ORGANIZATION_FAIL' });
    dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
  });

  if (updatedOrganization) {
    if (file) {
      updatedOrganization.pictureFileName = await uploadOrganizationPicture(file, organizationId);

      await setOrganization(organizationId, updatedOrganization).catch(error => {
        dispatch({ type: 'UPDATE_ORGANIZATION_FAIL' });
        dispatch({ type: 'OPEN_ERROR', payload: 'Error updating Organization' });
      });
    }

    updateOrganizationSuccess(organizationId, history, dispatch);
  }
}

export const updateOrganizationSuccess = (organizationId, history, dispatch) => {

  dispatch({ type: 'UPDATE_ORGANIZATION_SUCCESS' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'Organization updated !' });
  history.push('/organizations/read/' + organizationId);
};

export const updateOrganizationFail = (error, dispatch) => {

  dispatch({ type: 'UPDATE_ORGANIZATION_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: error });
};

export const organizationPictureChanged = file => dispatch => {
  dispatch({ type: "ORGANIZATION_PICTURE_CHANGED", payload: file });
};

const uploadOrganizationPicture = async (file, organizationId) => {

  var formData = new FormData();
  formData.append("files", file);

  const res = await fetch(
    process.env.REACT_APP_API_URL + "/api/organizations/upload-file/" + organizationId,
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  )
    .then(function (response) {
      return response.json();
    })
    //.then(handleErrors)
    .then(function (body) {
      return body;
    });

  return res
};


export const getOrganizationStart = (organizationId) => async (dispatch) => {

  dispatch({ type: 'GET_ORGANIZATION_START' });
  let organization = await getOrganization(organizationId);
  let balance = null;
  if(organization.type === enums.OrganizationTypes.UTILITY) {
    balance = await getUtilityOrganizationBalanceAccount(organizationId);
    dispatch({ type: 'GET_UTILITY_ORGANIZATION_BALANCE_ACCOUNT_SUCCESS', payload: balance });
  }


  dispatch({ type: 'GET_ORGANIZATION_SUCCESS', payload: organization });
};

export const getOrganizationFormStart = (organizationId) => async (dispatch) => {

  dispatch({ type: 'GET_ORGANIZATION_FORM_START' });

  let organization = await getOrganization(organizationId);

  dispatch({ type: 'GET_ORGANIZATION_FORM_SUCCESS', payload: organization });
  return organization;
};

export const resetCurrentOrganization = () => async (dispatch) => {
  dispatch({ type: 'RESET_ORGANIZATION' });
};

export const getOrganization = async (organizationId) => {
  return await fetch(process.env.REACT_APP_API_URL + "/api/organizations/" + organizationId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data
    })
    .catch(error => {
      console.error(error);
    });
}

export const getOrganizationSuccess = (organizationId, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_SUCCESS' });
};

export const getOrganizationFail = (organizationId, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

export const organizationNameChanged = (name) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_NAME_CHANGED', payload: name });
};

export const organizationBlockchainAddressChanged = (address) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_BLOCKCHAIN_ADDRESS_CHANGED', payload: address });
};

export const organizationTypeChanged = (type) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_TYPE_CHANGED', payload: type });
};

export const organizationParentOrganizationChanged = (organizationId) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_PARENT_ORGANIZATION_CHANGED', payload: organizationId });
};

export const organizationMatchingTypeChanged = (matchingType) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_MATCHING_TYPE_CHANGED', payload: matchingType });
};

export const organizationContactFirstnameChanged = (contactFirstname) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_CONTACT_FIRSTNAME_CHANGED', payload: contactFirstname });
};

export const organizationContactLastnameChanged = (contactLastname) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_CONTACT_LASTNAME_CHANGED', payload: contactLastname });
};

export const organizationContactPhoneNumberChanged = (contactPhoneNumber) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_CONTACT_PHONENUMBER_CHANGED', payload: contactPhoneNumber });
};

export const organizationContactEmailChanged = (contactEmail) => (dispatch) => {
  dispatch({ type: 'ORGANIZATION_CONTACT_EMAIL_CHANGED', payload: contactEmail });
};

export const organizationAutomaticMatchingLiveEnabledChanged = (automaticMatchingLiveEnabled) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ORGANIZATION.AUTOMATIC_MATCHING_LIVE_ENABLED_CHANGED, payload: automaticMatchingLiveEnabled });
};

export const organizationAutomaticMatchingOfficialEnabledChanged = (automaticMatchingOfficialEnabled) => (dispatch) => {
  dispatch({ type: ACTION_TYPE.ORGANIZATION.AUTOMATIC_MATCHING_OFFICIAL_ENABLED_CHANGED, payload: automaticMatchingOfficialEnabled });
};

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

const handleCatchedErrors = err => {
  throw Error(err);
};

export const getOrganizations = () => async (dispatch) => {
  dispatch({ type: 'GET_ORGANIZATIONS_START' });

  let organizationEndPointURL = process.env.REACT_APP_API_URL + "/api/organizations/";

  let organizations = null;

  try {
    organizations = await getRequest(organizationEndPointURL);
    dispatch({ type: 'GET_ORGANIZATIONS_SUCCESS', payload: organizations });
  } catch (error) {
    console.error(error);
    dispatch({ type: 'GET_ORGANIZATIONS_FAIL' });
    dispatch({ type: 'OPEN_GENERIC_ERROR' });
  }

  return organizations;
}

export const getUtilityOrganizationBalanceAccount = async (organizationId) => {
  return await fetch(process.env.REACT_APP_API_URL + "/api/organizations/"+organizationId+"/balance", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async balance => {
      return balance
    })
    .catch(error => {
      console.error(error);
    });
}

export const getOrganizationUsers = (organizationId) => async (dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_USERS_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/users/organizations/"+organizationId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async organizationUsers => {
      getOrganizationUsersSuccess(organizationUsers, dispatch);
      return organizationUsers
    })
    .catch(error => {
      console.error(error);
      getOrganizationUsersFail(error, dispatch);
    });
}


export const getOrganizationUsersSuccess = (organizationUsers, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_USERS_SUCCESS', payload: organizationUsers });
};

export const getOrganizationUsersFail = (error, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_USERS_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

//////////
export const getOrganizationAssetsProducing = (organizationId) => async (dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_PRODUCING_ASSETS_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/prod/organization/"+organizationId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async organizationProducingAssets => {
      getOrganizationAssetsProducingSuccess(organizationProducingAssets, dispatch);
      return organizationProducingAssets
    })
    .catch(error => {
      console.error(error);
      getOrganizationAssetsProducingFail(error, dispatch);
    });
}


export const getOrganizationAssetsProducingSuccess = (organizationProducingAssets, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_PRODUCING_ASSETS_SUCCESS', payload: organizationProducingAssets });
};

export const getOrganizationAssetsProducingFail = (error, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_PRODUCING_ASSETS_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

//////////

export const getOrganizationAssetsConsuming = (organizationId) => async (dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_CONSUMING_ASSETS_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/consum/organization/"+organizationId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async organizationAssetsConsuming => {
      getOrganizationAssetsConsumingSuccess(organizationAssetsConsuming, dispatch);
      return organizationAssetsConsuming
    })
    .catch(error => {
      console.error(error);
      getOrganizationAssetsConsumingFail(error, dispatch);
    });
}


export const getOrganizationAssetsConsumingSuccess = (organizationAssetsConsuming, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_CONSUMING_ASSETS_SUCCESS', payload: organizationAssetsConsuming });
};

export const getOrganizationAssetsConsumingFail = (error, dispatch) => {
  dispatch({ type: 'GET_ORGANIZATION_CONSUMING_ASSETS_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};

//////////

const createOrganization = async (organization) => {
  let json = JSON.stringify(organization);

  return await fetch(
    process.env.REACT_APP_API_URL +
    "/api/organizations/add",
    {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: json
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);

}

const setOrganization = async (organizationId, organization) => {
  const json = JSON.stringify(organization);

  return await fetch(process.env.REACT_APP_API_URL + "/api/organizations/" + organizationId, {

    method: 'PUT',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    body: json
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);

}

export const getParentOrganizations = () => async (dispatch) => {
  dispatch({ type: 'GET_PARENT_ORGANIZATIONS_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/organizations/", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async parentOrganizations => {
      const parentOrganizationsFiltered = parentOrganizations.filter(organization => {
        return organization.type === enums.OrganizationTypes.UTILITY || organization.type === enums.OrganizationTypes.TEO
      })
      getParentOrganizationsSuccess(parentOrganizationsFiltered, dispatch);
      return parentOrganizationsFiltered
    })
    .catch(error => {
      console.error(error);
      getParentOrganizationsFail(error, dispatch);
    });
}

export const getParentOrganizationsSuccess = (parentOrganizations, dispatch) => {
  dispatch({ type: 'GET_PARENT_ORGANIZATIONS_SUCCESS', payload: parentOrganizations });
};

export const getParentOrganizationsFail = (error, dispatch) => {
  dispatch({ type: 'GET_PARENT_ORGANIZATIONS_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: "An error occured, try later or refresh the page" });
};



// WEBPACK FOOTER //
// ./src/actions/OrganizationActions.js